
import { Component, Input } from '@angular/core';
import { NgxHmCarouselBreakPointUp, NgxHmCarouselComponent, NgxHmCarouselItemDirective } from 'ngx-hm-carousel';
import { BannerService } from '@core/services/banner/banner.service';
import { NgClass } from '@angular/common';
import { DeferImageLoadDirective } from '../../directives/defer-image-load.directive';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-banner-mojo',
    templateUrl: './banner-mojo.component.html',
    styleUrls: ['./banner-mojo.component.scss'],
    standalone: true,
    imports: [NgxHmCarouselComponent, NgxHmCarouselItemDirective, FormsModule, DeferImageLoadDirective, NgClass]
})
export class BannerComponent {

    @Input() images: any;
    @Input() autoplay: boolean;
    infiniteScroll = true;
    bannerIndex: number = 0;

    breakPoint: NgxHmCarouselBreakPointUp[] = [{ width: 1024, number: 1 }];

    constructor(private bannerService: BannerService) { }

    openActionLink(imageData: any, index: number) {
        this.bannerService.openActionLink(imageData, index);
    }
}
